<template>
    <div>
        <v-tabs v-model="tabId">
            <v-tab v-for="tab in tabs" :key="'tab'+tab.id">{{tab.title}}</v-tab>
            <v-tab v-if="tabs.length>0 && bewerb?.settings?.modus !== 'tabelle'">Endergebnis</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tabId" touchless>
            <v-tab-item v-for="tab in tabs" :key="'tabItem'+tab.id" class="pt-5">
                <div v-for="(rundenId, i) in bewerb?.getSortedRundenIdsForTab(tab.id)" :key="tab+rundenId">
                    <meisterschaft-runde
                        :runde="bewerb.runden[rundenId]"
                        :bewerb="bewerb"
                        :landesverband-id="landesverbandId"
                        @refreshBewerb="refreshBewerb"
                        @editSettings="editSettings"
                        @editTeam="editTeam"
                        @editResult="editResult"
                        @editSpielResult="editSpielResult"
                        @confirmClearSpiel="confirmClearSpiel"
                    />
                    <v-divider v-if="bewerb?.getSortedRundenIdsForTab(tab.id).length>1 &&
                                    (i+1)<bewerb?.getSortedRundenIdsForTab(tab.id).length" class="mb-5"/>
                </div>
            </v-tab-item>
            <v-tab-item v-if="tabs.length>0 && bewerb.settings.modus!=='tabelle'" class="pt-5">
                <meisterschaft-bewerb-ko-ergebnis :bewerb="bewerb"/>
            </v-tab-item>
        </v-tabs-items>
    </div>

</template>

<script>

import MeisterschaftRunde from "@/views/ergebnisdienst/meisterschaft/runden/meisterschaftRunde.vue";
import MeisterschaftBewerbKoErgebnis from "@/views/ergebnisdienst/meisterschaft/meisterschaftBewerbKoErgebnis.vue";

export default {
    name: "meisterschaftRunden",
    components: {MeisterschaftBewerbKoErgebnis, MeisterschaftRunde},
    props: ['bewerb', 'landesverbandId'],
    computed: {
        tabs(){return this.bewerb?.getTabs()??[]}
    },
    data: () => ({
        tabId: 0,
    }),
    methods: {
        refreshBewerb(bewerbTyp){
            this.$emit('refreshBewerb',bewerbTyp)
        },
        editSettings(params){
            this.$emit('editSettings', params);
        },
        editTeam(params){
            this.$emit('editTeam', params);
        },
        editSpielResult(spiel){
            this.$emit('editSpielResult', spiel);
        },
        editResult(params){
            this.$emit('editResult', params);
        },
        confirmClearSpiel(params){
            this.$emit('confirmClearSpiel', params);
        }
    },
}
</script>

<style scoped>

</style>